import variadic from './variadic.js'
import patternToRegExp from './pattern-to-regexp.js'
import _ from 'underscore'

export default class ErrorCollection {
    constructor (errors = {}) {
        this.errors = errors
    }

    /**
     * Determine if the collection has any errors.
     */
    hasErrors () {
        return !_.isEmpty(this.errors)
    }

    /**
     * Determine if the collection has errors for a given field.
     */
    has (...fields) {
        const properties = variadic(fields)

        return properties.filter(key => this.matching(key).length > 0).length > 0
    }

    matching (pattern) {
        let regexp = patternToRegExp(pattern)

        return this.keys().filter(key => regexp.test(key))
    }

    first (...fields) {
        const properties = variadic(fields)

        if (properties.length === 0 && this.isEmpty) {
            return null
        }

        return this.errors[properties[0]][0]
    }

    /**
     * Get all of the raw errors for the collection.
     */
    all () {
        return this.errors
    }

    /**
     * Get all of the errors for the collection in a flat array.
     */
    flatten () {
        return _.flatten(_.toArray(this.errors))
    }

    /**
     * Get the first error message for a given field.
     */
    get (field) {
        if (this.has(field)) {
            return this.errors[field][0]
        }
    }

    /**
     * Set the raw errors for the collection.
     */
    set (errors) {
        if (typeof errors === 'object') {
            this.errors = errors
        } else {
            this.errors = { 'form': ['Something went wrong. Please try again or contact customer support.'] }
        }
    }

    forget () {
        this.errors = {}
    }

    keys () {
        return Object.keys(this.errors)
    }

    remove (field) {
        delete this.errors[field]
    }

    removeStartingWith (pattern) {
        this.keys().forEach(key => {
            if (key.startsWith(pattern)) {
                this.remove(key)
            }
        })
    }

    /**
     * Determine if the collection is not empty.
     *
     * @returns {boolean}
     */
    isNotEmpty () {
        return this.isEmpty() === false
    }

    /**
     * Determine if the collection is empty
     *
     * @returns {boolean}
     */
    isEmpty () {
        return Object.values(this.errors).length === 0
    }
}
